import { constants } from "../constants/global.constants";
import { getFirebase } from 'react-redux-firebase';
import { refUpdate, refSave } from './entity.actions';
import { alertActions } from './alert.actions';

export const scheduleActions = {
  openScheduleDrawer,
  closeScheduleDrawer,
  addSchedule,
  editSchedule,
  selectSchedule
};

export function filterTasksBySchedule(tasksMap, scheduleTaskMap){
    const checkedTasksMap = !!tasksMap ? tasksMap : {}
    const checkScheduleTaskMap = !!scheduleTaskMap ? scheduleTaskMap :  {}
    return Object.keys(checkedTasksMap).filter(item => !!checkScheduleTaskMap[item]).reduce((obj, key) => {
        return {
        ...obj,
            [key]: checkedTasksMap[key]
        };
    }, {})
}

function openScheduleDrawer(scheduleId, scheduleName, tasks) {

    return async (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_SCHEDULE_DRAWER,
            scheduleId,
            scheduleName,
            scheduleTasks: tasks,
        });
    };
}

function closeScheduleDrawer() {
     return async (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_SCHEDULE_DRAWER,
        });
    };
}

function selectSchedule(scheduleId) {
    return async (dispatch, getState) => {
        dispatch({
            type: constants.SELECT_SCHEDULE,
            scheduleId: scheduleId
        });
    };
}

function addSchedule(schedule, projectId) {
    const firebase = getFirebase();

    return async (dispatch, getState) => {
        const entityRoute = `/projects/${projectId}/schedules/`;

        const ref = firebase.database().ref(entityRoute);

        const newKey = ref.push().key;
        dispatch(addScheduleLoading());
        refSave(
            firebase,
            firebase.database().ref(`${entityRoute}${newKey}`),
            schedule
        )
            .then(() => {
                dispatch(addScheduleStopLoading());
            })
            .catch(e => {
                dispatch(alertActions.error('Error Saving schedule'));
                dispatch(addScheduleStopLoading());
            });
    };

    function addScheduleLoading() {
        return {
            type: constants.ADD_SCHEDULE_LOADING,
               
        };
    }

    function addScheduleStopLoading() {
        return {
            type: constants.ADD_SCHEDULE_STOP_LOADING,
               
        };
    }
}

function editSchedule(scheduleId, schedule, projectId) {
    const firebase = getFirebase();

    return async (dispatch, getState) => {
        const entityRoute = `/projects/${projectId}/schedules/`;
        dispatch(addScheduleLoading());

        delete schedule['tableData']
        delete schedule['uid']


        refUpdate(
            firebase,
            firebase.database().ref(`${entityRoute}${scheduleId}`),
            schedule
        )
            .then(() => {
                dispatch(addScheduleStopLoading());
            })
            .catch(e => {
                dispatch(alertActions.error('Error Updating schedule'));
                dispatch(addScheduleStopLoading());
            });
    };

    function addScheduleLoading() {
        return {
            type: constants.ADD_SCHEDULE_LOADING,
               
        };
    }

    function addScheduleStopLoading() {
        return {
            type: constants.ADD_SCHEDULE_STOP_LOADING,
               
        };
    }
}



// WEBPACK FOOTER //
// ./src/actions/schedule.actions.js